"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionPayloadsRequestToJSON = exports.RosettaConstructionPayloadsRequestFromJSONTyped = exports.RosettaConstructionPayloadsRequestFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionPayloadsRequestFromJSON(json) {
    return RosettaConstructionPayloadsRequestFromJSONTyped(json, false);
}
exports.RosettaConstructionPayloadsRequestFromJSON = RosettaConstructionPayloadsRequestFromJSON;
function RosettaConstructionPayloadsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'operations': (json['operations'].map(_1.RosettaOperationFromJSON)),
        'public_keys': !runtime_1.exists(json, 'public_keys') ? undefined : (json['public_keys'].map(_1.RosettaPublicKeyFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.RosettaConstructionMetadataResponseMetadataFromJSON(json['metadata']),
    };
}
exports.RosettaConstructionPayloadsRequestFromJSONTyped = RosettaConstructionPayloadsRequestFromJSONTyped;
function RosettaConstructionPayloadsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'operations': (value.operations.map(_1.RosettaOperationToJSON)),
        'public_keys': value.public_keys === undefined ? undefined : (value.public_keys.map(_1.RosettaPublicKeyToJSON)),
        'metadata': _1.RosettaConstructionMetadataResponseMetadataToJSON(value.metadata),
    };
}
exports.RosettaConstructionPayloadsRequestToJSON = RosettaConstructionPayloadsRequestToJSON;
//# sourceMappingURL=RosettaConstructionPayloadsRequest.js.map